export const ClassesConstService = {
  PROP_XINGSHOU: 2,
  PROP_JINGYING: 3,
  // 直播
  CLASSES_PROP_LIVING: 1,

  /** 核算实训平台classesProp */
  CLASSES_PROP_COST_ACC: [2, 3, 5, 6],

  /** 乐私塾自己的课程,直播和普通 */
  // CLASSES_PROP_NORMAL: [0, ClassesConstService.CLASSES_PROP_LIVING],

  /** 题库模考 */
  CLASSES_PROP_MOCK: [12, 141, 142],

  /** 行业 */
  CLASSES_PROP_HY: [11],
  /** APOIT行业 */
  CLASSES_PROP_APOIT_HY: ['41', '42', '43', '44', '45', '46', '47', '48', 'b0fad761a68469127a3c1472f52dcd99'],
  /** 智慧课堂 */
  CLASSES_PROP_OFFLINE: '14',

  // 会计代账练习
  CLASSES_PROP_AGENT: [8],
  // 沙盘
  CLASSES_PROP_SHAPAN: [13],
  // 已报名
  CLASSES_SIGN_UP: '1',

  // 设计乐实训课程课程ID
  CLASSED_IDS: ['e82e785c3273c223789c403ae4f1b84a', '35c12617c3a4187028945a4239fa1076'],

  // 直播课
  checkIsLiving(classesPorp) {
    this.globalUtil.equals(classesPorp, ClassesConstService.CLASSES_PROP_LIVING)
  },

  // 公开课
  isKjssOpenClasses(classesProp, licenseCode) { // 公开课
    //   return this.checkIsLiving(classesProp) && this.globalUtil.equals(licenseCode, HomeConstService.KJSS)
  },

  /** 检查是否普通课程 */
  checkIsNormal(classesPorp) {
    return checkIsIn(classesPorp, ClassesConstService.CLASSES_PROP_NORMAL)
  },
  /** 行业 */
  checkIsHY(classesPorp) {
    return checkIsIn(classesPorp, ClassesConstService.CLASSES_PROP_HY)
  },
  checkIsOffline(classesPorp) {
    return this.globalUtil.equals(classesPorp, ClassesConstService.CLASSES_PROP_OFFLINE)
  },

  /** 判断报班 */
  checkSign(isSign) {
    return this.globalUtil.equals(isSign, ClassesConstService.CLASSES_SIGN_UP)
  },
  /** 校验是否是设计乐实训课程 */
  checkIsDesignPratice(classesId) {
    return ClassesConstService.CLASSED_IDS.indexOf(classesId) > -1
  }
}

export function checkIsIn(e, array) {
  for (const item of array) {
    console.log('11111111111111', item, e)
    if (item.toString() === e.toString()) {
      return true
    }
  }
  return false
}
/** 校验是否核算 */
export function checkIsAccCost(classesPorp) {
  return checkIsIn(classesPorp, ClassesConstService.CLASSES_PROP_COST_ACC)
}
/** 模考 */
export function checkIsMock(classesPorp) {
  return checkIsIn(classesPorp, ClassesConstService.CLASSES_PROP_MOCK)
}
/** APOIT行业 */
export function checkIsAPOITHY(classesPorp) {
  return checkIsIn(classesPorp, ClassesConstService.CLASSES_PROP_APOIT_HY)
}
export function checkIsAGENT(classesPorp) {
  return checkIsIn(classesPorp, ClassesConstService.CLASSES_PROP_AGENT)
}
export function checkIsSHAPAN(classesPorp) {
  return checkIsIn(classesPorp, ClassesConstService.CLASSES_PROP_SHAPAN)
}
